import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const LeadsRoute = [
    {
        path: '/leads',
        component: React.lazy(() => import('./Leads.js')),
        auth: AuthRoles.editor,
    }
]

export default LeadsRoute;